import { render, staticRenderFns } from "./VestMgt.vue?vue&type=template&id=fd815336&"
import script from "./VestMgt.vue?vue&type=script&lang=js&"
export * from "./VestMgt.vue?vue&type=script&lang=js&"
import style0 from "./VestMgt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports